import { useMediaQuery } from '@vueuse/core';
import { breakpointsPx } from '@/utils/constants/common';

export function useScreens() {
  const isTablet = useMediaQuery(`(min-width: ${breakpointsPx.md})`);

  const isMobile = useMediaQuery(`(max-width: ${breakpointsPx.md})`);

  return { isTablet, isMobile };
}
